import { FC } from 'react';
import { EstateStatusProps, estateStatusMapToText } from './EstateStatus.types';
import { commonStatusStyle, styles, textStyle } from './EstateStatus.styles';
import clsx from 'clsx';

const EstateStatus: FC<EstateStatusProps> = ({ estateStatus, size }) => {
  const statusStyle = styles[estateStatus];
  const textStatusStyle = size ? textStyle(size) : 'text-xs md:text-sm lg:text-[15px]';
  const combinedStyle = clsx(statusStyle, commonStatusStyle, textStatusStyle);
  return (
    <div className={combinedStyle}>
      <span>{`${estateStatusMapToText[estateStatus]}`}</span>
    </div>
  );
};

export { EstateStatus };
